import { useEffect, useRef, useState } from "react";
import { Grid, LinearProgress, Typography } from "@mui/material";

import { useUi } from "@/context/util/ui";

export function LoadingContainer() {
  const { loading } = useUi();
  return (
    <Grid
      className={loading ? "loader" : "hide"}
      sx={{
        display: loading ? "fixed" : "none",
        width: "100%",
        height: "calc(100vh - 64px)",
      }}
    />
  );
}

export function LoadingElements() {
  const [progress, setProgress] = useState<number>(0);
  const [buffer, setBuffer] = useState<number>(10);

  const { loading } = useUi();

  const progressRef = useRef(() => {});
  useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles && jssStyles.parentElement) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
    const timer = loading
      ? setInterval(() => {
          progressRef.current();
        }, 500)
      : null;

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [loading]);

  return (
    <>
      <Typography
        color="primary"
        sx={{
          display: loading ? "fixed" : "none",
          position: "relative",
          top: "30vh",
          zIndex: 99999,
        }}
        variant="h3"
        component="p"
      >
        Loading
      </Typography>
      <LinearProgress
        variant="buffer"
        value={progress}
        valueBuffer={buffer}
        sx={{ display: loading ? "fixed" : "none", top: "33vh" }}
      />
    </>
  );
}
